export const DescriptionContent = ({ id, description }) => {
    if (id === 8 || id === 10 || id === 16) {
      const descriptionItems = description.split('.').filter(item => item.trim() !== '');
      return (
        <ul style={{ color: '#ccc', textAlign: 'start', padding:'0px !important',listStyleType: 'disc' }}>
          {descriptionItems.map((item, index) => (
            <li key={index} style={{color: '#ccc',   marginBottom: '0.5em' }}>
              {item.trim()}
            </li>
          ))}
        </ul>
      );
    }
  

    return <p style={{ color: '#ccc', textAlign: 'center', padding:0}}>{description}</p>;
  };